import * as React from "react"
import { Box, Typography } from "@mui/material"
import { formatPrice } from "@ui-seeker/utils"

import { NotAllowedBlock } from "@components"


export default function priceColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			headerAlign: 'center',
			customBodyRowRenderLite: (value, { currency }) => !value
				? <Box sx={{ textAlign: 'center' }}><NotAllowedBlock sx={{ fontWeight: 'bold' }}/></Box>
				: <Typography variant="body2" sx={{ textAlign: 'center' }}>
					{formatPrice(value, currency)}
				</Typography>
		}
	}
}